import CloseIcon from '@mui/icons-material/Close';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { assertUnreachable, paths, generateUrl } from 'shared/base';

import { PlatformVersionUpgradeDetails } from './platformVersionUpgradeDetails';

export type State =
  | { type: 'closed' }
  | {
      newVersion: string;
      newVersionReleaseDate: Date;
      oldVersion: string;
      type: 'open';
    };

interface Props {
  onClose: () => void;
  state: State;
}

export const PlatformVersionUpgradeDialog = ({ onClose, state }: Props) => {
  switch (state.type) {
    case 'closed': {
      return <Dialog open={false} />;
    }
    case 'open': {
      return (
        <Dialog fullWidth={true} onClose={onClose} open={true}>
          <DialogTitle>
            <Box alignItems="center" display="flex" justifyContent="space-between">
              <Typography variant="h6">CloudQuery Platform Upgrade Summary</Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            <PlatformVersionUpgradeDetails
              newVersion={state.newVersion}
              newVersionReleaseDate={state.newVersionReleaseDate}
              oldVersion={state.oldVersion}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              href={generateUrl({
                pathname: paths.platform.settings.organization.updates,
              })}
              LinkComponent={Link}
              sx={{ width: 'fit-content' }}
              variant="contained"
            >
              All platform updates
            </Button>
          </DialogActions>
        </Dialog>
      );
    }
    default: {
      return assertUnreachable(state);
    }
  }
};
